import { IsBoolean } from 'class-validator';

export class AuctionHighlightedUpdateOnManagementModel {
  @IsBoolean()
  public highlighted: boolean;
}
